<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="confirm"></progress-components>
    </v-container>
    <v-container class="mx-auto mt-8">
      <v-row justify="center" align-content="center" class="mb-6">
        <v-col align="center"><span class="text-lg-h6 font-weight-bold red--text">こちらの内容でよろしければ「送信」を押してください。</span>
        </v-col>
      </v-row>
      <v-row justify="center" align-content="center" class="mb-6">
        <v-btn
          :disabled="isDisableSendBtn"
          dark
          x-large min-width="400px"
          color="success"
          class="mb-4 mx-4"
          @click="clickedSubmit"
        >送信
        </v-btn>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, computed } from 'vue'
import { Logger } from 'aws-amplify'
import { useRouter } from 'vue-router'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/MedicalRecordTitle.vue'
import ProgressComponents from '@/components/MedicalRecordProgress.vue'
import { useScreenOperation } from '@/func/useScreenOperation'

const logger = new Logger('AdvanceForm');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents
  },
  setup() {
    const { scrollToTop, fromConfirmScreen } = useScreenOperation()
    const fromConfirm = computed(() => fromConfirmScreen())

    logger.info('MedicalRecord Confirm')
    scrollToTop()

    const router = useRouter()
    const toBack = () => router.go(-1)

    const clickedSubmit = () => {
      router.push('/record/done')
    }
    return {
      fromConfirm,
      clickedSubmit,
      toBack
    }
  }
})
</script>
